import React, { useState } from "react";
import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

/**
 * Material UI Breadcrumb component
 * 
 * @returns {JSX.Element} Breadcrumb component
 */
export const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const [activeButton, setActiveButton] = useState<string>("");
  
  // Set active state based on current location or clicked item
  const isActive = (path: string): boolean => {
    return activeButton === path || location.pathname.toLowerCase() === path.toLowerCase();
  };

  // Style for active link
  const activeLinkStyle = {
    color: 'primary.main',
    fontWeight: 700,
    textDecoration: 'none',
  };

  // Style for inactive link
  const linkStyle = {
    color: 'text.primary',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  // Style for current page (non-clickable)
  const currentPageStyle = {
    color: 'primary.main',
    fontWeight: 700,
  };

  // Determine if we should show Choose Machine breadcrumb
  const showChooseMachine = location.pathname.toLowerCase().includes('/choosemachine') || 
                           location.pathname.toLowerCase().includes('/productdesigns') ||
                           location.pathname.toLowerCase().includes('/finalparameters');

  return (
    <Box
      sx={{
        py: 1.5,
        px: 3.75,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          component={RouterLink}
          to="/Dashboard"
          onClick={() => setActiveButton("/Dashboard")}
          sx={isActive("/Dashboard") ? activeLinkStyle : linkStyle}
          underline="none"
        >
          Dashboard
        </Link>
        <Link
          component={RouterLink}
          to="/Design"
          onClick={() => setActiveButton("/Design")}
          sx={isActive("/Design") ? activeLinkStyle : linkStyle}
          underline="none"
        >
          Choose Industry
        </Link>
        {showChooseMachine && (
          <>
            {isActive("/choosemachine") ? (
              <Typography sx={currentPageStyle}>
                Choose Machine
              </Typography>
            ) : (
              <Link
                component={RouterLink}
                to="/choosemachine"
                onClick={() => setActiveButton("/choosemachine")}
                sx={linkStyle}
                underline="none"
              >
                Choose Machine
              </Link>
            )}
          </>
        )}
        {location.pathname.toLowerCase().includes('/finalparameters') && (
          <Typography sx={currentPageStyle}>
            Final Parameters
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb; 